// src/contexts/FilterContext.tsx
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import axios from "axios";

interface Match {
    title: string;
    matchDate: string;
    sharedWith: string[];
    score: string;
    half: string;
    [key: string]: any;
}

interface MatchboardData {
    data: Match;
}

// Define the shape of the context value
interface MatchboardContextProps {
    pageData: MatchboardData | undefined;
    setPageData: React.Dispatch<React.SetStateAction<MatchboardData | undefined>>;
}

// Create the context with a default value
const MatchboardContext = createContext<MatchboardContextProps | undefined>(undefined);

// Create a provider component
const MatchboardProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [pageData, setPageData] = useState<MatchboardData>();

    return (
        <MatchboardContext.Provider value={{ pageData, setPageData }}>
            {children}
        </MatchboardContext.Provider>
    );
};

// Custom hook to use the filter context
const useMatchboardContext = () => {
    const context = useContext(MatchboardContext);
    if (context === undefined) {
        throw new Error('usePage must be used within a PageProvider');
    }
    return context;
};

export { MatchboardProvider, useMatchboardContext };
